// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import eng from './eng';
import de from './german';
import moment from 'moment';
import 'moment/locale/de';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: eng,
            },
            de: {
                translation: de,
            },
        },
        lng: 'de', // Set the default language
        fallbackLng: 'en', // Fallback language
        interpolation: {
            escapeValue: false, // React already escapes values by default
        },
    });

    i18n.on('languageChanged', (lng) => {
        moment.locale(lng);
      });

export default i18n;
